export enum AuthProvider {
    None = 0,
    Google = 1,
    Instagram = 2
}
